import { render, staticRenderFns } from "./ViewCertificateModal.vue?vue&type=template&id=d72d9bf8"
import script from "./ViewCertificateModal.vue?vue&type=script&lang=js"
export * from "./ViewCertificateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports